import React, {useEffect, useState} from "react"

const ProgressBar = ({initialMilliseconds}: any) => {
  const [milliseconds, setMiliseconds] = useState(initialMilliseconds)
  const [percentage, setPercentage] = useState(100)

  useEffect(() => {
    const timer = setInterval(() => {
      if (milliseconds > 0) {
        setMiliseconds(milliseconds - 1000)
        setPercentage((milliseconds - 1000) / initialMilliseconds * 100)
      }
    }, 1000)

    return () => {clearInterval(timer)}
  }, [milliseconds, initialMilliseconds])

  return(
      <div className="progress-container">
        <span className="progress-bar" style={{ width: `${percentage}%` }}></span>
      </div>
  )
}

export default ProgressBar